module.exports = __webpack_public_path__ + "static/avatar_denis_kostyakov-40373413aaa5f77648b7e138fc9bc243.jpg";